import { render } from "./HeroiconsSolidSearch.vue?vue&type=template&id=5784da68"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSearch.vue"]])

export default __exports__